// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Control } from './Control';
import StepProgressBarTemplate from '@front/templates/StepProgressBarTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
export class StepProgressBar extends Control {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.StepProgressBar;
    }
    oninit() {
        super.oninit();
        this.observe('labels', this.onLabelsChanged);
    }
    onLabelsChanged(labels) {
        if (!isValidArray(labels)) {
            return;
        }
        void this.set('numberOfSteps', labels.length);
    }
}
Control.extendWith(StepProgressBar, {
    template: StepProgressBarTemplate,
    data: () => ({
        currentStep: 1,
        numberOfSteps: 3,
        labels: []
    })
});
